import { render } from "./Drawing.vue?vue&type=template&id=6f7c7c29&scoped=true"
import script from "./Drawing.vue?vue&type=script&lang=js"
export * from "./Drawing.vue?vue&type=script&lang=js"

import "./Drawing.vue?vue&type=style&index=0&id=6f7c7c29&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7c7c29"]])

export default __exports__